import { post } from 'utils';

export const getAppointManSelectData = req =>
  post('/Basic/Approval/getAppointManSelectData', req).then(res => res.res || []);
